import React from 'react';
import PropTypes from 'prop-types';

import SubmitButton from '../SubmitButton';

import Icon from '../../../../../assets/images/pro/amazon-pay@2x.png';

import * as styles from '../styles/styles.module.scss';

const PayWithAmazonButton = ({ text, handler }) => {
  const content = (
    <span className={styles.contents}>
      {text}
      <img className={styles.amazonPayIcon} src={Icon} />
    </span>
  );

  return <SubmitButton text={content} handler={handler} variant="amazonCheckout" />;
};

PayWithAmazonButton.defaultProps = {
  text: 'Checkout with Amazon',
  handler: () => {}
};

PayWithAmazonButton.propTypes = {
  text: PropTypes.string,
  handler: PropTypes.func
};

export default PayWithAmazonButton;
